/* eslint-disable */
// Your Attendance card (iter-126k, slice 8a of EventDetail.jsx refactor).
//
// Shown to logged-in players who are part of the band (hidden for
// info-only contacts, per iter-66k). Renders 3 status buttons
// (Attending / Can't Attend / Maybe), a per-event short note for
// admins, and — when status = "not_attending" — an "Invite a Dep"
// shortcut that opens the InviteDepDialog at page level.
import React from "react";
import { Check, HelpCircle, UserPlus, X } from "lucide-react";
import { Card, CardContent } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";


export const YourAttendanceCard = ({
  myPlayerProfile,
  user,
  myAttendance,
  myNote,
  setMyNote,
  handleMyAttendanceChange,
  handleSaveMyNote,
  setInviteDepOpen,
}) => {
  // Hidden entirely for info-only contacts (iter-66k) and people who
  // aren't a player on this band (e.g. admin viewing other people's bands).
  if (!myPlayerProfile || user?.is_info_only) return null;

  return (
    <Card className="glass-card border-primary/20">
      <CardContent className="p-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
              <UserPlus className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="font-heading font-medium text-lg">Your Attendance</h3>
              <p className="text-sm text-muted-foreground">
                {myAttendance ? `Current status: ${myAttendance.status.replace('_', ' ')}` : "You haven't responded yet"}
              </p>
            </div>
          </div>
          <div className="flex flex-wrap gap-2">
            <Button
              variant={myAttendance?.status === "attending" ? "default" : "outline"}
              className={myAttendance?.status === "attending" ? "bg-green-600 hover:bg-green-700" : ""}
              onClick={() => handleMyAttendanceChange("attending")}
              data-testid="my-attending-btn"
            >
              <Check className="w-4 h-4 mr-2" />
              Attending
            </Button>
            <Button
              variant={myAttendance?.status === "not_attending" ? "default" : "outline"}
              className={myAttendance?.status === "not_attending" ? "bg-red-600 hover:bg-red-700" : ""}
              onClick={() => handleMyAttendanceChange("not_attending")}
              data-testid="my-not-attending-btn"
            >
              <X className="w-4 h-4 mr-2" />
              Can&apos;t Attend
            </Button>
            <Button
              variant={myAttendance?.status === "maybe" ? "default" : "outline"}
              className={myAttendance?.status === "maybe" ? "bg-yellow-600 hover:bg-yellow-700" : ""}
              onClick={() => handleMyAttendanceChange("maybe")}
              data-testid="my-maybe-btn"
            >
              <HelpCircle className="w-4 h-4 mr-2" />
              Maybe
            </Button>
          </div>
        </div>

        {/* Notes — players can leave a short note alongside their response */}
        <div className="mt-5 pt-5 border-t border-white/10">
          <label className="text-xs uppercase tracking-wider text-muted-foreground font-medium mb-2 block" htmlFor="my-attendance-note">
            Note for admins (optional)
          </label>
          <div className="flex gap-2">
            <Input
              id="my-attendance-note"
              value={myNote}
              onChange={(e) => setMyNote(e.target.value)}
              placeholder="e.g. arriving 10 min late, bringing music stand, happy to play 2nd..."
              maxLength={300}
              className="flex-1"
              data-testid="my-attendance-note-input"
            />
            <Button
              variant="outline"
              onClick={handleSaveMyNote}
              data-testid="save-my-note-btn"
            >
              Save note
            </Button>
          </div>
          {myAttendance?.notes && (
            <p className="text-xs text-muted-foreground mt-2 italic">
              Current saved note: &ldquo;{myAttendance.notes}&rdquo;
            </p>
          )}
        </div>

        {/* iter-55: ALWAYS show the invite-dep option when the user can't
            attend — even if no deps are registered yet (they can add a
            new person on the spot). */}
        {myAttendance?.status === "not_attending" && (
          <div className="mt-4 pt-4 border-t border-white/10">
            <p className="text-sm text-muted-foreground mb-3">
              Can&apos;t make it? Help us find a dep to cover your seat.
            </p>
            <Button
              variant="outline"
              onClick={() => setInviteDepOpen(true)}
              className="border-blue-400/30 text-blue-400 hover:bg-blue-500/10"
              data-testid="invite-dep-from-attendance-btn"
            >
              <UserPlus className="w-4 h-4 mr-2" />
              Invite a Dep
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default YourAttendanceCard;
